import { render, staticRenderFns } from "./StyleguideTreeMenu.vue?vue&type=template&id=a0a41c40&scoped=true&"
import script from "./StyleguideTreeMenu.vue?vue&type=script&lang=ts&"
export * from "./StyleguideTreeMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a41c40",
  null
  
)

export default component.exports